import React from 'react';
import { DirectoryBar } from '../components/DirectoryBar';
import { H1 } from '../components/H1';

const data = [
  {
    year: 1855,
    description:
      'Hamilton Carhartt는 New York의 Macedon Locks에서 출생하였습니다.',
  },
  {
    year: 1889,
    description:
      '5명의 직원과 4개의 재봉틀로, 노동조합의 조건에 맞는 덕 캔버스와 데님 소재의 오버롤을 생산하기 시작하였습니다. ',
  },
  {
    year: 1910,
    description:
      'Carhartt 사는 Detroit, Dallas 그리고 San Francisco에 생산공장을 설립하였으며, Georgia와 South Carolina에 두 곳의 면직 공장까지 설립, 확장하였습니다.',
  },
  {
    year: 1911,
    description:
      'Carhartt Automobile Corporation은 “자동차 산업의 첨단”이라는 모토 아래 1년에 약 300 여대의 “Pleasure Cars”를 생산하였습니다.',
  },
  {
    year: 1914,
    description:
      '제1차 세계 대전 당시, Carhartt는 군인들의 작업복을 생산하였으며, 17개의 공장들과 함께 20세기 초 10,20여 년간 의류회사로서 큰 성공을 이루었습니다.',
  },
  {
    year: 1923,
    description:
      'Carhartt CO1 Chore Coat가 처음으로 광고에 출시되었고 Carhartt 컬렉션의 핵심적인 아이템으로 거듭났습니다.',
  },
  {
    year: 1932,
    description:
      'Carhartt는 Irvine, Kentucky에 새로운 공장을 설립하며, 세계 경제 대공황 당시 실직된 수천 명의 임시 노동자들이 속해 있는 산업 단지의 열악한 환경에 더 좋은 작업환경을 제공하자는 “Back to the Land”라는 캠페인을 시행하였습니다.',
  },

  {
    year: 1937,
    description:
      'Hamilton Carhartt는 82세의 나이로 Grosse Pointe, Michigan에서 교통사고로 사망하였으며, Carhartt 사는 그의 아들들인 Hamilton Jr와 Wylie에게 상속되었습니다.',
  },
  {
    year: 1941,
    description:
      '세계 2차 대전에 미국이 참전하게 되면서, 전쟁 물자를 지원하는 공장들이 대량으로 가동하며 미국 전 경제가 급성장을 경험하게 되었으며, 이에 미국 내 외에 거주하고 있던 군인들이 내구성 있고 견고한 의류들을 필요로 하게 되었습니다.',
  },
  {
    year: 1966,
    description:
      '봄 컬렉션에는 대표적으로 “Hugger pants”와 “Surfers”를 포함한 캔버스 원단을 사용한 클래식 스포츠 의류, 캐주얼 재킷, 청바지와 셔츠를 출시하게 되었습니다.',
  },
  {
    year: 1989,
    description: 'Carhartt는 설립 100주년을 맞이하였습니다.',
  },
  {
    year: 1989,
    description:
      '“All American Concept”라는 타이틀과 함께, Edwin Faeh는 유럽 시장에 독특한 방식으로 Carhartt를 소개하기 시작하였습니다.',
  },
  {
    year: 1992,
    description:
      '힙합 아티스트, 그래피티 아티스트 등 여러 아티스트들이 Carhartt를 입기 시작하며, 좋은 퀄리티와 실용적인 디자인의 브랜드로 입소문 타기 시작하였습니다.',
  },
  {
    year: 1994,
    description:
      'Edwin Faeh는 Europe내 Carhartt의 독점 유통사로서 Work in Progress (WIP) 사를 설립하였습니다.',
  },
  {
    year: 1995,
    description:
      '유럽의 언더그라운드 음악, 문화 저변에 인기를 얻으며 좋은 분위기를 유지하고 있는 가운데, Mathieu Kassovitz의 영화 “La Haine”에 Carhartt의 제품이 등장하며, Carhartt 제품이 등장한 최초의 영화가 되었습니다.',
  },
  {
    year: 1996,
    description:
      'Work In Progress 사는 미국 외 다른 나라에서 Carhartt 제품을 제작할 수 있는 라이센스를 취득하였으며, 다음 해 첫 컬렉션을 출시하였습니다.',
  },
  {
    year: 1997,
    description:
      '첫 Carhartt WIP 매장이 London의 Neal Street에 오픈 되었습니다.',
  },
  {
    year: 1997,
    description: 'Carhartt WIP는 자체 스케이트팀과 BMX 팀을 구성하였습니다.',
  },
  {
    year: 1999,
    description: 'Evan Hecox가 브랜드 캠페인 광고 이미지를 제작하였습니다.',
  },
  {
    year: 2000,
    description: 'Carhartt WIP는 첫 여성 컬렉션을 출시하였습니다.',
  },
  {
    year: 2000,
    description:
      'Edwin Faeh, Oliver Drewes, 그리고 Philipp Maiburg는 새로운 일렉트로닉 음악의 오픈 플랫폼으로서 Combination Records를 설립하였습니다.',
  },
  {
    year: 2003,
    description:
      'Carhartt WIP의 출판 Rugged Magazine의 창간호가 발매되었습니다.',
  },
  {
    year: 2007,
    description:
      'Bildschöne Bücher & Carhartt WIP의 출판 Alexander Basile, Pontus Alv and Bertrand Trichet 제작 "Dirt Ollies: A Skateboard Trip to Mongolia"가 발매되었습니다.',
  },
  {
    year: 2008,
    description:
      '레코드 레이블과 아티스트들의 새로운 플랫폼을 제안하기 위한 Carhartt WIP Radio가 첫 출시되었습니다.',
  },
  {
    year: 2010,
    description:
      'Carhartt WIP는 비슷한 이념과 느낌을 가진 브랜드들과 함께 캡슐 컬렉션과 스페셜 프로젝트들을 협업하기 시작하였습니다. 그 후 수년 동안, A.P.C, Converse, Fragment Design, Junya Watanabe, Nike, Patta, Vans, Vestax 그리고 Vetements과 같은 브랜드와의 협업을 진행하였습니다.',
  },
  {
    year: 2011,
    description:
      'Carhartt WIP는 브랜드의 근본인 미국의 뿌리를 되찾아, New York City에 스토어를 오픈하였습니다.',
  },
  {
    year: 2013,
    description: 'Antiz Skateboards와 협업을 진행하였습니다.',
  },
  {
    year: 2014,
    description: 'Carhartt WIP는 설립 25주년을 맞이하였습니다.',
  },
  {
    year: 2015,
    description:
      '“Dir Ollies”의 Mongolia의 재방문을 기념으로 “From Dirt to Dust ”를 출시하였습니다.',
  },
  {
    year: 2016,
    description:
      '“The Carhartt WIP Archives”책이 출시되었습니다. Rizzoli 사에서 출판하였으며, Carhartt WIP의 광범위한 역사를 다루는 책으로 큰 의미가 있습니다. 반면, 브랜드의 스케이트 팀은 미국과 호주에서도 첫 스케이터들을 맞이하였습니다.',
  },
  {
    year: 2017,
    description:
      'Carhartt WIP는 Isle Skateboards와 협업을 진행하였으며 Raphaël Zarka의 아트 인스톨레이션 “Paving Space”를 함께 출시하였습니다. 또한 Carhartt WIP는 더욱 오랫동안 지속 가능한 면을 생산하는 회사로 참여하며 Better Cotton Initiative (BCI)의 회원으로서 활동하게 됩니다. 추가적으로, 이 해에 Detroit 테크노 아이콘인 Undergrond Resistance와 협업을 진행하였으며, 연 2회 출간되는 WIP magazine 잡지를 출간하였습니다.',
  },
  {
    year: 2018,
    description:
      'Carhartt WIP는 러시아 스케이트 브랜드인 PACCBET과 협업하였으며, 음악적으로는 영국 레게와 더브 음악 레이블인 Trojan과 특별 캡슐 컬렉션을 출시하였습니다. 또한 Moodymann의 Detroit 축제에서 상영한 다큐멘터리 Soul skate를 출시하였습니다. 동시에, Carhartt WIP Radio는 10주년을 맞이하였습니다.',
  },
  {
    year: 2019,
    description:
      'Carhartt WIP는 Los Angeles에 미국에서 두 번째 매장을 설립하였습니다. 또한 이 해 컬렉션에 유기농 면을 소개하며 이 원사로 제작한 컬렉션을 소개하였으며 호주 레이블인 PASS-PORT Skateboards와 협업을 진행하였습니다. 게다가, Motown과 Fela Kuti에 경의를 표하는 두 캡슐 컬렉션을 제작하였습니다.',
  },
  {
    year: 2020,
    description:
      'Carhartt WIP는 계속해서 제품군들을 확장하고 있으며, GORE-TEX INFINIUM과 Converse와 협업을 진행 중에 있습니다. Galleria Continua와 함께 다양한 제품들과 더불어 스케이트 영상, Paris 근처의 Boissy-le-Châtel의 콘크리트 스케이트 파크의 설립 기념 출간물을 출시하였으며 Awake NYC와의 협업을 진행하였습니다.',
  },
  {
    year: 2021,
    description:
        'Carhartt WIP는 프랑스 파리의 St-Germain-Des-Prés 지역에 새롭게 매장을 오픈했으며 두 번째 칼하트윕 관련 팟캐스트 시리즈가 출시했습니다. 아티스트 Lucas Price와 협업해 가을 캠페인부터 베를린의 스케이트보드 브랜드 Civilist 그리고 L\' Art de l\' Automobile을 위한 유화 페인팅 시리즈를 선보입니다.',
  },
  {
    year: 2022,
    description:
        'Carhartt WIP는 런던의 유명한 디자인 스튜디오이자 패션 브랜드 Toogood과 협업해 Salone del Mobile에서 컬렉션을 선보였습니다. 연말에는 New Balance 및 Liberty Fabrics 그리고 스케이트보드 브랜드 Quartersnacks과 함께 협업 컬렉션을 선보였습니다. 독일 함부르크와 스페인 바르셀로나에 새로운 플래그십 스토어를 오픈했습니다.',
  },
];
export const HistoryPage = () => {
  return (
    <>
      <DirectoryBar text="홈, 칼하트윕에 대하여" />
      <div className="max-w-3xl mx-auto space-y-6 pb-20">
        <H1 className="font-bold text-center pb-20">칼하트윕에 대하여</H1>

        <p className="">
          1994년 Edwin Faeh가 설립한 Carhartt Work In Progress (칼하트 WIP)는
          미국의 오리지널 워크웨어 브랜드 Carhartt를 기반으로 하고 있으며 설립
          이후 매 시즌 Carhartt WIP 컬렉션을 선보이고 있습니다. 기반이 튼튼한
          아메리칸 스타일의 의류와 Carhartt가 꾸준히 포용해왔던 서브컬처를
          결합함으로써 칼하트WIP는 기존의 클래식함을 유지함과 동시에 그들만의
          새로움을 컬렉션을 통해 보여주고 있습니다. 
          <br />
          <br />
          Carhartt WIP는 1997년 런던에 첫 매장을 오픈하였으며 오늘날 전 세계
          80여 개국에 매장을 운영하고 있습니다. 또한 자체 칼하트 WIP 스케이트
          팀과 음악 부서를 운영하고 있으며, 다방면의 아티스트를 지원함과 동시에
          여러 출판물을 출시했습니다. 2010년 이후부터는 A.P.C, Converse,
          Fragment Design, Junya Watanabe, Nike와 같은 유수의 브랜드와 협업을
          진행하였으며 Underground Resistance, Motown과 같은 유명 음악 레이블과
          협업하였습니다.
        </p>

        {data.map((item) => (
          <div className="">
            <h2 className="font-bold">{item.year}</h2>
            <p className="">{item.description}</p>
          </div>
        ))}
      </div>
    </>
  );
};
